// Fonction permettant de convertir une chaîne composée de 10 chiffres
// en un numéro de téléphone sous la forme : "00-00-00-00-00"
// Le séparateur peut-être modifié en changer la valeur de 'sep'
export const formatPhoneNumber = (phoneNumber, sep="-") => {
    return phoneNumber.slice(0, 2) + sep + phoneNumber.slice(2, 4) + sep + phoneNumber.slice(4, 6) + sep + phoneNumber.slice(6, 8) + sep + phoneNumber.slice(8, 10);
};